module.exports = __webpack_public_path__ + "static/maverick-a4c57c7347162d8f33efa1f755efba17.jpg";